import { LocalService } from './../../../../core/services/storage/local.service';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { AtencionService } from './../../../../core/services/http/atencion.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { ModalService } from './../../../../core/services/utils/modal.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-motivos-atencion-claro',
  templateUrl: './modal-motivos-atencion-claro.component.html',
  styleUrls: ['./modal-motivos-atencion-claro.component.css']
})
export class ModalMotivosAtencionClaroComponent implements OnInit {
  listamotivos!: any;
  idTurno!: string;
  cierre!: boolean;
  pausa!: boolean;
  urgencia!: boolean;
  motivoSelec = new FormControl('', [Validators.required]);
  isSubmitted = false;
  observacion: string = '';
  motivosForm!: FormGroup;
  respMotivo: any;
  respErrMotivo: any;


  constructor(
    private modalService: ModalService,
    private config: NgSelectConfig,
    private formBuilder: FormBuilder,
    private atencion: AtencionService,
    private emit: EmitService,
    private localSecureService: LocalService
  ) { this.config.notFoundText = 'No se encotraron registros'; }

  ngOnInit(): void {
    this.setForm();
  }

  setForm() {
    this.motivosForm = this.formBuilder.group({
      observaciones: ['']
    });
  }

  submit() {
    this.isSubmitted = true;
    if (this.motivoSelec.invalid) {
      return;
    }

    if (this.motivosForm.controls.observaciones.value == '') {
      this.observacion = "Ninguna"
    } else {
      this.observacion = this.motivosForm.controls.observaciones.value
    }



    if (this.cierre || this.pausa || this.urgencia) {
      const dataMotivos = JSON.stringify({
        "idTurno": this.idTurno,
        "listaMotivos": this.motivoSelec.value + ',1;',
        "observacion": this.observacion
      });
      this.enviarMotivos(dataMotivos);
    } else {
      const motivosTurno = {
        listaMotivos: this.motivoSelec.value + ',1;',
        observaciones: this.observacion
      }
      this.localSecureService.setValue('motivosTurno', motivosTurno);
      this.closeModal();
      this.emit.enviarData('finTurno');

    }

  }

  async enviarMotivos(dataMotivos: any) {
    await this.atencion.ingresaMotivos(dataMotivos).then((data) => {
      this.respMotivo = data;
    }).catch((error) => {
      this.respErrMotivo = error;
    });

    if (this.respMotivo) {
      this.closeModal();
      if (this.cierre) {
        this.emit.enviarData('finTurnoSesion');
      } else {
        if (this.pausa) {
          this.emit.enviarData('finTTurno');
        } else {
          if (this.urgencia) {
            this.emit.enviarData('urgencia');
          }
        }
      }
    } else {
      this.closeModal();
      this.emit.enviarData('failPausa');
    }

  }

  closeModal(): void {
    this.modalService.closeModal();
  }

  cerrar() {
    this.closeModal();
  }

}
